import { render, staticRenderFns } from "./MKBTable.vue?vue&type=template&id=45d0a7af"
import script from "./MKBTable.vue?vue&type=script&lang=js"
export * from "./MKBTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports